import getIn from 'transmute/getIn';
// @ts-expect-error getIn incorrectly yields a result of unknown
export const selectSortOrder = getIn(['findAndFilterData', 'searchAndFilter', 'sortOrder', 'data']);